import {
	createComment,
	createReply,
	deleteComment,
	editComment,
	getCommentReactionCounts,
	getCommentReactions,
	registerCommentReaction,
	doesUserHaveAccess,
	findUsers,
	getCommentsList
} from "client/Api/Communities/communityPostViewer";
import { HubCommentSectionService } from "../HubCommentSection/HubCommentSection";
import { ReactionKind } from "client/Api/Hub/common";
import { createUrlRelativeToEnvironment } from "client_legacy/ndaw/navigator";

export function getCommunityCommentService(
	postId: number
): HubCommentSectionService {
	function withCommunityPostId<TArgs extends unknown[], TResult>(
		callback: (postId: number, ...args: TArgs) => Promise<TResult>
	): (...args: TArgs) => Promise<TResult> {
		return (...args: TArgs): Promise<TResult> => callback(postId, ...args);
	}

	return {
		createComment: withCommunityPostId(createComment),
		createReply: withCommunityPostId(createReply),
		deleteComment: withCommunityPostId(deleteComment),
		doesUserHaveAccess: withCommunityPostId(doesUserHaveAccess),
		editComment: withCommunityPostId(editComment),
		findUsers: withCommunityPostId(findUsers),
		getCommentReactionCounts: withCommunityPostId(getCommentReactionCounts),
		getCommentReactions: withCommunityPostId(getCommentReactions),
		registerCommentReaction: withCommunityPostId(registerCommentReaction),
		updateCommentReaction: withCommunityPostId(registerCommentReaction),
		unregisterCommentReaction: (commentId: number, signal: AbortSignal) => {
			return withCommunityPostId(registerCommentReaction)(
				commentId,
				ReactionKind.NoReaction,
				signal
			);
		},
		getCommentsList: withCommunityPostId(getCommentsList),
		getCommentImageUrl: getCommunityCommentImageUrl
	};
}

function getCommunityCommentImageUrl(imageId: string): string {
	return createUrlRelativeToEnvironment(
		`/Hub/Communities/Comments/Image/?imageId=${encodeURIComponent(imageId)}`
	);
}